import Helper from "../Helper";

export default class SearchExtended {

  /**
   * Constructor for SearchExtended
   *
   * @param {Search} context
   */
    constructor(context)
    {
        this.$extendableWrapper = $('[data-search="main"]');
        this.extendState = this.$extendableWrapper.data('extendable');
        this.typeOfSearch = this.$extendableWrapper.data('searchtype');
        this.$extendableParent = this.$extendableWrapper.closest('[data-extendable-parent]');
        this.searchName = this.$extendableWrapper.data('search');
        this.isDefaultSearch = 0;
        this.$logo = $('[data-changelogo]');
        this.context = context;
        this.initWidth = $(window).width();

        this.init();
    }

    /**
     * Init function
     */
    init()
    {
        this.extendState = this.extendState === 1;

        if (this.typeOfSearch === 'biggerSearch') {
            if (Helper.isTabletOrLower()) {
                this.closeSearch();
                this.hideExtendSearch();
                this.changeLogoColor('default');
            } else {
                this.bigSearch();
                this.changeLogoColor('white');
            }
            this.resizeSearch();
        }
        this.$extendableWrapper.find('[data-extendable-toggle]').click((event) => {
            this.openCloseSearch(event)
        });
    }


  /**
   * This function open search.
   *
   * @param e
   */
    openCloseSearch(e)
    {
        e.preventDefault();
        if (this.extendState) {
            this.closeSearch();
        } else {
            this.openSearch();
        }
        if (this.$extendableWrapper.is('[data-search]')) {
            this.animation();
        }
    }

  /**
   * This function opens and closes the search engine depending on the height of the site.
   * Works only on certain pages that have data attribute type of search on biggerSearch.
   */
    bigSearch()
    {
        let search = $('[data-search-actions-origins]');

        $(window).scroll((event) => {
            let scroll = $(window).scrollTop();
            let searchOffsetTop = search.offset().top;

            if (scroll >= searchOffsetTop && !this.isDefaultSearch) {
                if (this.extendState) {
                    this.closeSearch();
                    $('[data-mobile-search-open]').removeClass('background-transparent');
                    this.setDefaultHeader();
                    if (!Helper.isTabletOrLower()) {
                        $('[data-changeColor]').removeClass('white');
                        window.searches[this.searchName].handleExtension(this.extendState, false);
                    }
                }
            } else if (scroll === 0 && this.isDefaultSearch) {
                this.openSearch();
                $('[data-mobile-search-open]').addClass('background-transparent');
                this.setExtendedHeader();
                if (!Helper.isTabletOrLower()) {
                    $('[data-changeColor]').addClass('white');
                }
                window.searches[this.searchName].handleExtension(this.extendState, false);
            }
        });
    }

  /**
   * This function open search
   *
   */
    openSearch()
    {
        this.$extendableWrapper.addClass('extended extended--big-search');
        this.$extendableParent.addClass('child-extended');
        this.$extendableWrapper.data('extendable', 1);
        this.extendState = true;
        this.showExtendSearch();

        if (this.typeOfSearch === 'biggerSearch') {
            if (Helper.isTabletOrLower()) {
                $('[data-extendable-toggle]').removeClass('background-white');
                $('[data-mobile-search-open]').addClass('background-transparent');
            } else {
                $('[data-changeColor]').removeClass('white');
            }
            window.searches[this.searchName].handleExtension(this.extendState, false);
        }
    }

  /**
   * This function close search
   *
   */
    closeSearch()
    {
        // If is the extendable is also search, handle backward extension manually
        if (!this.$extendableWrapper.is('[data-search]') || !Helper.isMobileOrLower()) {
            this.hideExtendSearch();
            this.context.hideDatepicker();
        } else if (Helper.isMobileOrLower()) {
            // Hide search specific stuff around extendable search (handle showing manually in search)
            this.$extendableParent.find('[data-search-extend-hide]').hide();
        }
        this.$extendableWrapper.removeClass('extended extended--big-search');
        this.$extendableParent.removeClass('child-extended');
        this.$extendableWrapper.data('extendable', 0);
        this.extendState = false;
        $('html').css('overflow-y', 'unset');

        if (this.typeOfSearch === 'biggerSearch') {
            $('[data-changeColor]').addClass('white');
            if (Helper.isTabletOrLower()) {
                $('[data-extendable-toggle]').addClass('background-white');
                $('[data-mobile-search-open]').addClass('background-transparent');
            }
        }
    }

  /**
   * this Function performs a transition
   */
    animation()
    {
        if (this.extendState) {
            $('[data-search-extend-hide="' + this.searchName + '"]').addClass('hidden-mvio');
        } else {
            let time = (Helper.isBigMobileOrLower()) ? 300 : 150;
            setTimeout(() => {
                $('[data-search-extend-hide="' + this.searchName + '"]').removeClass('hidden-mvio');
            }, time); // 0.3s is transition for search extension, so little bit less
        }
        window.searches[this.searchName].handleExtension(this.extendState, true);
    }

    /**
    * This function sets the default search
    */
    setDefaultHeader()
    {
        this.isDefaultSearch = 1;
        this.extendState = false;
        $('[data-contentbackground]').removeClass('set-negative-margin');
        this.$extendableParent.removeClass('no-sticky background-transparent');
        this.$extendableParent.addClass('with-shadow');
        this.$logo.removeClass('flaticon-svg--white');
        this.$logo.addClass('flaticon-svg--default');
        this.$logo.parent().removeClass('nav-logo--hide-border');
    }

    /**
    * This function sets the extended search
    */
    setExtendedHeader()
    {
        this.isDefaultSearch = 0;
        this.extendState = true
        $('[data-contentbackground]').addClass('set-negative-margin');
        this.$extendableParent.addClass('no-sticky background-transparent');
        this.$extendableParent.removeClass('with-shadow');
        this.changeLogoColor('white');
        this.$logo.parent().addClass('nav-logo--hide-border');
    }

    /**
    * This function change logo color.
    *
    * @param {String} color
    */
    changeLogoColor(color)
    {
        this.$logo.removeClass();
        this.$logo.addClass('flaticon-svg--' + color);
    }

    /**
    * This function sets the search according to the width of browser window
    */
    resizeSearch()
    {
        $(window).resize((e) => {
            if (Helper.isAndroid()) {
                if ((this.initWidth !== $(window).width()) && ($(window).width() <= window.tabletBreakpoint)
                    || $(window).scrollTop() > 20) {
                    this.closeSearch();
                    this.changeLogoColor('default');
                    $('[data-dim="search"]').hide();
                } else if (($(window).width() > window.tabletBreakpoint)
                && $(window).scrollTop() <= 20) {
                    this.extendState = true;
                    this.$extendableWrapper.addClass('extended');
                    this.bigSearch();
                    this.showExtendSearch();
                    this.changeLogoColor('white');
                }
            } else {
                if ($(window).width() <= window.tabletBreakpoint
                || $(window).scrollTop() > 20) {
                    if (this.initWidth !== $(window).width()) {
                        this.closeSearch();
                        this.changeLogoColor('default');
                        $('[data-dim="search"]').hide();
                    }
                } else {
                    this.extendState = true;
                    this.$extendableWrapper.addClass('extended');
                    this.bigSearch();
                    this.showExtendSearch();
                    this.changeLogoColor('white');
                }
            }
        });
    }

    /**
    * This function hide extend search
    */
    hideExtendSearch()
    {
        if (!Helper.isTabletOrLower()) {
            this.$extendableWrapper.removeClass('animation-slide-up');
        } else {
            this.$extendableParent.find('[data-header-sticky]').addClass('with-shadow');
        }

        this.$extendableWrapper.find('[data-extendable-full]').addClass('hidden-mvio');
        this.$extendableWrapper.find('[data-extendable-preview]').removeClass('hidden-mvio');
        this.$extendableWrapper.find('[data-extendable-preview]').removeClass('show-preview-search');
        this.$extendableWrapper.find('[data-extendable-full]').removeClass('show-big-search');
    }

    /**
    * This function show extend search
    */
    showExtendSearch()
    {
        if (!Helper.isTabletOrLower()) {
            this.$extendableWrapper.addClass('animation-slide-up');
            this.$extendableParent.find('[data-header-sticky]').removeClass('with-shadow');
        }

        this.$extendableWrapper.find('[data-extendable-preview]').addClass('hidden-mvio');
        this.$extendableWrapper.find('[data-extendable-full]').removeClass('hidden-mvio');
        this.$extendableWrapper.find('[data-extendable-full]').removeClass('show-big-search');
    }
}